<template>
  <div class="gmap-main">
    <RemarksBox title="Default Remarks" :text.sync="data.remarks" style="height: 100px" :isDisabled="viewMode" />
    <div class="flex-row">
      <Input placeholder="Average Stuff Time (Hour(s))" style="padding-right: 5px" :inputValue.sync="data.avgStuffTime" :isDisabled="viewMode" />
      <Input placeholder="Average Unstuff Time (Hour(s))" style="padding-left: 5px" :inputValue.sync="data.avgUnstuffTime" :isDisabled="viewMode" />
    </div>
    <div class="flex-row">
      <Input placeholder="Container Count (Ability to store # of containers)" style="padding-right: 5px" :inputValue.sync="data.containerCount" :isDisabled="viewMode" />
      <!--<Input placeholder="PKNet ID" style="padding-left: 5px" :inputValue.sync="data.isTransit" :isDisabled="viewMode" />-->
    </div>
    <GmapLocation :data="data" :isGeofence="true" :showGeofence.sync="data.showGeofence" :viewMode="viewMode"/>
  </div>
</template>

<script>
/* eslint-disable */
import Input from '@/components/Input.vue';
import CheckBox from '@/components/CheckBox.vue';
import RemarksBox from '@/components/RemarksBox.vue';
import GmapLocation from '@/components/GmapLocation.vue';

export default {
  components: {
		Input, CheckBox, RemarksBox, GmapLocation,
  },
  props: {
    data: { type: Object, default: function() { return {} } },
    viewMode: { type: Boolean, default: false },

  },
  methods: {
  },
  watch: {
    data: {
      deep: true,
      handler(val) {
      }
    },

  },
  mounted() {
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.flex-row {
  display: flex;
  padding-top: 5px;
}

.coords-col {
  width: 50%;
}

#divGeofence {
  display: flex;
  justify-content: left;
}

#divInvGeofence {
  display: none;
}
</style>